import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { createTicketNote } from '../../../services/tickets';
import { ITicketNote } from '../../../services/tickets/types';
import { ICreateTicketNote } from '../../../pages/Tickets/types';

interface IProps {
  ticketId: string;
  payload: ICreateTicketNote;
}
export const ThunkCreateTicketNote = createAsyncThunk<ITicketNote, IProps>(
  `${storeResources.TICKETS}/createTicketNote`,
  ({ payload, ticketId }) =>
    createTicketNote(ticketId, payload).then(res => ({
      createdBy: payload.contactName,
      dateCreated: new Date().toISOString(),
      text: payload.note,
      id: new Date().getTime(),
      type: 'TicketNote',
    })),
);
